import { MAP_LAYER_IDS, SIDEBAR_VIEWS } from '../../../../lib/constants'
import Alert from '../../../Modals/Alert'
import Button from '../../../Button'
import AlertCircle from '../../../../assets/svg/Feather/AlertCircle'
import ghAnalytics from '../../../../lib/analytics'
import { getFeatureDisplayString } from '../../../../lib/features'
import Check from '../../../../assets/svg/Feather/Check'

export default (dispatch) => {
	const updateFeature = (feature, updates, updateGraphic = true) => {
		const updatedFeature = {
			...feature,
			...updates,
		}

		dispatch({
			type: 'map/closePopup',
		})

		dispatch({
			type: 'features/updateSelectedFeature',
			payload: updatedFeature,
		})
		dispatch({
			type: 'features/updateFeature',
			payload: updatedFeature,
		})
		if (updateGraphic) {
			dispatch({
				type: 'map/updateFeatureGraphic',
				payload: {
					feature: updatedFeature,
					layerId: MAP_LAYER_IDS.content,
				},
			})

			dispatch({
				type: 'map/updateFeatureGraphicAttributes',
				payload: {
					featureId: updatedFeature.uuid,
					layerId: MAP_LAYER_IDS.content,
					attributes: updates,
				},
			})
		}
	}

  const setFavorite = (type, value) => {
		let dispatchPayload = {}
		switch (type) {
			case 'icon': 
			dispatchPayload = { icon: value, type: 'icons' }
			break
		}
		dispatch({
			type: 'features/saveFeatureFavorites',
			payload: dispatchPayload
		})
	}

  const setSelectedIcon = (icon) => {
		dispatch({
			type: 'features/setSelectedIcon',
			payload: icon
		})
	}

	const toggleFeatureIconEditorSidebar = (action) => {
    if (action === 'open') {
      dispatch({
        type: 'app/gotoSidebarWithHistory',
        payload: SIDEBAR_VIEWS.FeatureIconEditor,
      });
    } else {
      dispatch({
        type: 'app/popSidebarHistory'
      });
      dispatch({
        type: 'app/gotoSidebar',
        payload: SIDEBAR_VIEWS.FeatureEditor,
      });
    }
  }
	const clearRecentWaypointStyles = () => {
		dispatch({ type: 'features/clearRecentWaypointStyles' })
	}

	return {
    addFavoriteIcon: (icon) => {
      setFavorite('icon', icon)
    },
		clearRecentStyles: () => {
			clearRecentWaypointStyles()
		},
    closeIconEdit: () => {
      toggleFeatureIconEditorSidebar('close')
    },
		openIconEdit: () => {
      toggleFeatureIconEditorSidebar('open')
    },
		selectIcon: (feature, color, icon) => {
			toggleFeatureIconEditorSidebar('close')
			setSelectedIcon(icon)
			updateFeature(feature, {
				properties: {
					...feature.properties,
					color,
					icon,
				},
			})
		},
    updateSelectedIcon: (icon) => {
      setSelectedIcon(icon)
    },
		updateFeatureTitle: (feature, title) => {
			updateFeature(feature, { title }, false)
		},
		updateWaypointStyle: (feature, color, icon) => {
			updateFeature(feature, {
				properties: {
					...feature.properties,
					color,
					icon,
				},
			})
			setSelectedIcon(icon)
		},
		updateFeatureColor: (feature, color) => {
			updateFeature(feature, { properties: { ...feature.properties, color } })
		},
		updateFeatureIcon: (feature, icon) => {
			updateFeature(feature, { properties: { ...feature.properties, icon } })
		},
		updateFeatureLineWeight: (feature, weight) => {
			updateFeature(feature, { properties: { ...feature.properties, strokeWidth: weight } })
		},
		showSaveFeatureError: () => {
			dispatch({
				type: 'modals/add',
				payload: {
					props: {
						title: 'There was an error saving your feature.',
						subtitle: '',
						actionItems: [
							{
								title: 'OK',
								theme: Button.THEME.solidPrimary,
								onClick: () => {
									dispatch({
										type: 'modals/close',
									})
								},
							},
						],
					},
					component: Alert,
				},
			})
		},
		saveFeature: (feature, hasFeatureErrored, featureErrorId) => {
			const featureType = getFeatureDisplayString(feature.properties.ghType)

			if (hasFeatureErrored) {
				dispatch({
					type: 'features/initNewFeature',
					payload: feature,
				})
				dispatch({
					type: 'toast/show',
					payload: {
						text: `Saving ${featureType}...`,
						loader: true,
					},
				})
				dispatch({
					type: 'features/saveFeatureEffect',
					callback: (featureId, error) => {
						if (featureId) {
							dispatch({
								type: 'features/getFeature',
								payload: featureId,
								callback: (feature) => {
									dispatch({
										type: 'features/addNewFeatureToUserData',
										payload: feature,
									})

									ghAnalytics.logCreateFeature(feature)

									dispatch({
										type: 'map/updateFeatureGraphicAttributes',
										payload: {
											featureId: featureErrorId,
											layerId: MAP_LAYER_IDS.content,
											attributes: feature,
										},
									})

									dispatch({
										type: 'toast/show',
										payload: {
											text: `${featureType} Saved`,
											icon: Check,
											iconColor: '#F37735',
										},
									})

									setTimeout(() => {
										dispatch({
											type: 'toast/dismiss',
										})
									}, 3500)

									dispatch({
										type: 'features/setFeatureError',
										payload: {
											featureErrorId: featureErrorId,
											hasFeatureErrored: false,
										},
									})

									// once the waypoint is saved, set it as selectedFeature, and then remove it from newWaypoint.
									dispatch({
										type: 'features/setSelectedFeature',
										payload: feature,
									})

									dispatch({
										type: 'features/cancelNewFeature',
									})

									dispatch({
										type: 'features/setPreviousFeatureState',
										payload: feature,
									})
								},
							})
						} else {
							dispatch({
								type: 'toast/show',
								payload: {
									text: 'There was an issue and your ' + featureType + ' was not saved.',
									icon: AlertCircle,
									iconColor: '#FF3B30',
									dismissable: true,
								},
							})

							dispatch({
								type: 'map/removeGraphicByFeatureId',
								payload: {
									featureId,
									layerId: MAP_LAYER_IDS.content,
								},
							})

							dispatch({
								type: 'features/setFeatureError',
								payload: {
									featureErrorId: featureId,
									hasFeatureErrored: true,
								},
							})
						}
					},
				})
			} else {
				dispatch({
					type: 'features/completeEditFeature',
				})

				dispatch({
					type: 'features/updateFeatureEffect',
					callback: (updateResult) => {
						if (!updateResult) {
							this.showSaveFeatureError()
							return
						}

						feature.properties.updatedAt = updateResult.updatedAt

						dispatch({
							type: 'features/setPreviousFeatureState',
							payload: feature,
						})

						dispatch({
							type: 'features/updateFeature',
							payload: feature,
						})

						dispatch({
							type: 'map/updateFeatureGraphic',
							payload: {
								feature: feature,
								layerId: MAP_LAYER_IDS.content,
							},
						})

						dispatch({
							type: 'map/updateFeatureGraphicAttributes',
							payload: {
								featureId: feature.uuid,
								layerId: MAP_LAYER_IDS.content,
								attributes: feature,
							},
						})

						ghAnalytics.logUpdateFeature(feature)

						dispatch({
							type: 'toast/show',
							payload: {
								text: `${featureType} Saved`,
								icon: Check,
								iconColor: '#F37735',
							},
						})

						dispatch({
							type: 'app/navSidebarBack'
						});

						setTimeout(() => {
							dispatch({
								type: 'toast/dismiss',
							})
						}, 3500)
					},
				})
			}

			dispatch({
				type: 'features/toggleEditingFeature',
			})
		},
		cancelEdit: () => {
			dispatch({
				type: 'features/cancelEditFeature',
			})
			dispatch({
				type: 'features/revertFeatureToPreviousState',
				callback: (previousFeatureState) => {
					dispatch({
						type: 'features/resetSelectedFeature',
						payload: previousFeatureState,
					})
				},
			})
			dispatch({ type: 'features/toggleEditingFeature' })
			dispatch({
				type: 'app/navSidebarBack'
			});	
			setSelectedIcon(null)
		},
	}
}
